export type FontSizeValue =
    | 'checkbox'
    | '14px'
    | 'small'
    | '18px'
    | 'medium'
    | 'large'
    | 'xLarge'
    | '40px'
    | '48px'
    | '64px';

export interface FontSizeBreakpointDescriptor {
    sizePx: number;
    lineHeight: number;
    letterSpacing: string;
}

export type FontSizeDescriptor = {
    base: FontSizeBreakpointDescriptor;
    tablet?: FontSizeBreakpointDescriptor;
    desktop?: FontSizeBreakpointDescriptor;
    internal?: boolean;
} & (
    | {
          advanced: true;
          labelI18nKey?: string;
          abbreviationI18nKey?: string;
      }
    | {
          advanced: false;
          labelI18nKey: string;
          abbreviationI18nKey: string;
      }
);

export type FontSizeConfig = Record<FontSizeValue, FontSizeDescriptor>;

// Types that are accepted from the embed iframe (used in NativeHtmlEmbedContent.svelte)
export enum IFrameMessageType {
    navigateToNextPage = 'navigateToNextPage',
    navigateToPageBySlug = 'navigateToPageBySlug',
}
